// 404 neutro — aplica los defaults de index.css si se renderiza fuera del
// ThemeProvider (ruta sin :partnerId). Texto intencionalmente vago para no
// filtrar si el partner no existe vs ruta invalida.
//
// Nivel 2 del roadmap (item 1.5): logo AuthSys neutral + styling alineado con el
// resto (AuthShell-like). El texto deriva al soporte del partner que redirigio
// (no exponemos un contacto propio). Cuando hay :partnerId valido se renderiza
// BrandedNotFound dentro del ThemeProvider (item 1.6, pendiente).

export default function NotFound(): JSX.Element {
  return (
    <main className="min-h-full flex flex-col items-center justify-center px-4 py-12 text-center bg-background text-text">
      <div className="max-w-md w-full space-y-6">
        <div className="flex justify-center" aria-hidden="true">
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="text-primary"
          >
            <rect x="6" y="6" width="44" height="44" rx="10" fill="currentColor" opacity="0.12" />
            <path
              d="M18 36V20l10 12V20m10 16V20"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-wider text-text-muted font-medium">
            Error 404
          </p>
          <h1 className="text-3xl font-semibold">No encontramos esa página</h1>
          <p className="text-sm text-text-muted leading-relaxed">
            Verificá el enlace o contactá al soporte del servicio que te
            redirigió hasta acá.
          </p>
        </div>
        <p className="text-xs text-text-muted pt-4">
          AuthSys
        </p>
      </div>
    </main>
  );
}
